import {
  GET_EMPLOYEE_DETAILS,
  GET_EMPLOYEE_DETAILS_START,
  GET_EMPLOYEE_DETAILS_FAIL,
  GET_CLIENT_NAMES,
  GET_CLIENT_NAMES_START,
  GET_CLIENT_NAMES_FAIL,
  GET_TIMECARD_WEEKS,
  GET_TIMECARD_WEEKS_START,
  GET_TIMECARD_WEEKS_FAIL,
  GET_JOB_NAMES,
  GET_JOB_NAMES_START,
  GET_JOB_NAMES_FAIL,
  // SHOW_MORE_EMPLOYEE_DETAILS,
  // NO_MORE_RECORDS,
  // LOADER_START,
  // LOADER_END,
  GET_EMPLOYEE_NAMES,
  GET_EMPLOYEE_NAMES_START,
  GET_EMPLOYEE_NAMES_FAIL
} from "../actions/actionTypes";

const DEFAULT_STATE = {
  isDataLoaded: false,
  isLoading: false,
  employeeDetails: {},
  // NO_MORE_RECORDS:false,
  // offset:1,
  // showMore: true,
  // records:"",
  // homeInitialLoader:false,
  timecardWeeks: {},
  clientNames: {},
  isClientDataLoaded: false,
  isJobNameLoaded: false,
  isTimeCardWeekLoaded: false,
  isEmpLoading: false,
  isEmpLoader:true,
  isEmployeeNameLoaded: false,
  offset:1,
  showMore: true,
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEE_DETAILS_START:
      return {
        ...state,
        isLoading: true
      };
    case GET_EMPLOYEE_DETAILS:
      return {
        ...state,
        isLoading: false,
        isDataLoaded: true,
        employeeDetails: action.employeeDetails.data,
        isEmpLoading: true,
        isEmpLoader:false,
        offset:1,
        showMore: true,
        // offset:1,
        // showMore: true,
        // records:action.employeeDetails.RecordCount,
      };
    // case SHOW_MORE_EMPLOYEE_DETAILS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     isDataLoaded: true,
    //     employeeDetails: [...state.employeeDetails,...action.employeeDetails.AdminHomeView],
    //     offset:state.offset + 1,
    //     records:action.employeeDetails.RecordCount
    //   }
    // case NO_MORE_RECORDS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     showMore: false
    //   }
    // case LOADER_START:
    //   return {
    //     ...state,
    //     homeInitialLoader: true,
    //   }
    // case LOADER_END:
    //   return {
    //     ...state,
    //     homeInitialLoader: false,
    //   }
    case GET_TIMECARD_WEEKS_START:
      return { ...state, isLoading: true };
    case GET_TIMECARD_WEEKS:
      return {
        ...state,
        isLoading: false,
        isDataLoaded: true,
        timecardWeeks: action.timecardWeeks.data.TimeCardWeeksDropDown,
        isTimeCardWeekLoaded: true
      };
    case GET_CLIENT_NAMES_START:
      return { ...state, isLoading: true };
    case GET_CLIENT_NAMES:
      return {
        ...state,
        isLoading: false,
        clientNames: action.clientNames.data.ClientDropDown,
        isClientDataLoaded: true
      };
    case GET_JOB_NAMES_START:
      return { ...state, isLoading: true };
    case GET_JOB_NAMES:
      return {
        ...state,
        isLoading: false,
        isDataLoaded: true,
        jobNames: action.jobNames.data.JobDropDown,
        isJobNameLoaded: true
      };

      case GET_EMPLOYEE_NAMES_START:
      return { ...state, isLoading: true };
    case GET_EMPLOYEE_NAMES:
      return {
        ...state,
        isLoading: false,
        isDataLoaded: true,
        employeeNames: action.employeeNames.data.EmployeeDropDown,
        isEmployeeNameLoaded: true
      };
    default:
      return state;
  }
};
